const getDefaultState = () => {
  return {
    tarificateur: {
      checkedRisque: '',
      step: 'choix',
      selectedRisque: 0,
      activeStep: { indexStep: 0, active: 'choix' },
      itemsRisque: [],
      risque: null,
      objet: null,
      prospect: null,
      conjoint: null,
      enfants: [],
      amis: [],
      parents: [],
      hasProduitAutoriser: false
    },
    tarifsData: [],
    produit: {
      produit_id: '',
      risque_id: '',
      produit_nom: '',
      nom_assureur: '',
      nom_com_assureur: ''
    },
    composeDataTarif: {
      dateEffet: null,
      enfantsArray: [],
      enfantCharge: 0,
      assurePrincipal: {
        regime: null,
        dateNaissance: null,
        codePostal: null
      },
      isConjoint: 0,
      conjoint: {
        regime: null,
        dateNaissance: null
      }
    }
  }
}

export default {
  state: getDefaultState(),
  mutations: {
    setProduitTarificateur(state, payload) {
      state.produit = payload
    },
    setTarifsData(state, payload) {
      state.tarifsData = payload
    },
    setComposeDataTarif(state, payload) {
      if (payload) {
        state.composeDataTarif = payload
      } else {
        state.composeDataTarif = {
          dateEffet: null,
          enfantsArray: [],
          enfantCharge: 0,
          assurePrincipal: {
            regime: null,
            dateNaissance: null,
            codePostal: null
          },
          isConjoint: 0,
          conjoint: {
            regime: null,
            dateNaissance: null
          }
        }
      }
    },
    setQWStepTarificateur(state, payload) {
      state.tarificateur.activeStep = payload.step
      state.tarificateur.step = payload.step.active
    },
    setQWCheckedRisque(state, payload) {
      state.tarificateur.checkedRisque = payload
    },
    setQWActiveStep(state, payload) {
      state.tarificateur.activeStep = payload.activeStep
    },
    setQWSelectedRisque(state, payload) {
      state.tarificateur.selectedRisque = payload.selectedRisque
    },
    setQWObjet(state, payload) {
      state.tarificateur.objet = payload.objet
    },
    setQWItemsRisque(state, payload) {
      state.tarificateur.itemsRisque = payload.itemsRisque
    },
    setQWProspect(state, payload) {
      state.tarificateur.prospect = payload.prospect
    },
    setQWConjoint(state, payload) {
      state.tarificateur.conjoint = payload.conjoint
    },
    setQWEnfants(state, payload) {
      state.tarificateur.enfants = payload.enfants
    },
    setQWAmis(state, payload) {
      state.tarificateur.amis = payload.amis
    },
    setQWParents(state, payload) {
      state.tarificateur.parents = payload.parents
    },
    setQWHasProduitAutoriser(state, payload) {
      state.tarificateur.hasProduitAutoriser = payload.hasProduitAutoriser
    },
    setQWState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    resetQWState({ commit }) {
      commit('setQWState')
    }
  },
  getters: {
    getProduitTarificateur(state) {
      return state.produit
    },
    getTarifsData(state) {
      return state.tarifsData
    },
    getComposeDataTarif(state) {
      return state.composeDataTarif
    },
    getQWCheckedRisque(state) {
      return state.tarificateur.checkedRisque
    },
    getQWStep(state) {
      return state.tarificateur.step
    },
    getQWActiveStep(state) {
      return state.tarificateur.activeStep
    },
    getQWSelectedRisque(state) {
      return state.tarificateur.selectedRisque
    },
    getQWObjet(state) {
      return state.tarificateur.objet
    },
    getQWItemsRisque(state) {
      return state.tarificateur.itemsRisque
    },
    getQWProspect(state) {
      return state.tarificateur.prospect
    },
    getQWConjoint(state) {
      return state.tarificateur.conjoint
    },
    getQWEnfants(state) {
      return state.tarificateur.enfants
    },
    getQWAmis(state) {
      return state.tarificateur.amis
    },
    getQWParents(state) {
      return state.tarificateur.parents
    },
    getQWHasProduitAutoriser(state) {
      return state.tarificateur.hasProduitAutoriser
    }
  }
}
